import React, { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./componants/Nav-section/DashboardLayout";
// import Loader from "./componants/Loader";
import FallbackLoader from "./componants/FallbackLoader";
const Login = lazy(() => import("./pages/Login"));
const Password = lazy(() => import("./pages/Password"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const RegisterWithGoogle = lazy(() => import("./pages/RegisterWithGoogle"));
const Dashboard = lazy(() => import("./pages/Dashboard"));

const LogInRoutes = () => {
  const routes = useRoutes([
    {
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        { path: "/dashboard", element: <Dashboard /> },
      ],
    },
    // { path: "/register", element: <Register /> },
    { path: "/password", element: <Password /> },
    { path: "/newpassword", element: <ForgotPassword /> },
    { path: "/register-with-google", element: <RegisterWithGoogle /> },
    {
      path: "/login",
      element: (
        <Suspense fallback={<FallbackLoader />}>
          <Login />
        </Suspense>
      ),
    },
  ]);

  return routes;
};

export default LogInRoutes;
